export const DATETIME_FORMAT = "yyyy-MM-dd HH:mm:ss";
export const DATETIME_DISPLAY_FORMAT = "yyyy-MM-dd HH:mm";
export const DATETIME_SECONDS_DISPLAY_FORMAT = "yyyy-MM-dd HH:mm:ss";
export const DATETIME_ZERO_SECONDS_DISPLAY_FORMAT = "yyyy-MM-dd HH:mm:00";

export const DATE_FORMAT = "yyyy-MM-dd";
export const DATE_DISPLAY_FORMAT = "yyyy-MM-dd"; 

export const TIME_FORMAT_MINUTES = "HH:mm";